<template>
  <div class="form-container">
    <!-- <hy-upload-single />
    <hy-upload-multiple />-->
    <div class="tips">
      尊敬的用户，为了保证您的投诉得到迅速准确办理，请您将真实情况如实填写，带 *
      号的项目均为必填项。
    </div>
    <div class="form">
      <div class="form-item">
        <span class="form-label required">真实姓名：</span>
        <span class="form-input">
          <input
            type="text"
            maxlength="10"
            v-model="complaintForm.name"
            placeholder="请填写真实姓名，限制十个字符"
          />
        </span>
      </div>
      <div class="form-item">
        <span class="form-label required">联系电话：</span>
        <span class="form-input">
          <input
            class="hy-link"
            type="text"
            v-model="complaintForm.phone"
            maxlength="30"
            placeholder="请填写手机或座机号码，限制三十字符"
          />
        </span>
      </div>
      <div class="form-item ">
        <span class="form-label required">投诉类型：</span>
        <span class="form-input">
          <el-select v-model="complaintCategory" placeholder="请选择">
            <el-option
                    v-for="item of complaintCategoryOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            >
            </el-option>
          </el-select>
        </span>
      </div>
      <div class="form-item">
        <span class="form-label required">身份证（正面）：</span>
        <span class="form-input form-upload">
          <hy-upload-single @uploadChange="uploadFront" />
        </span>
      </div>
      <div class="form-item">
        <span class="form-label required">身份证（反面）：</span>
        <span class="form-input form-upload">
          <hy-upload-single @uploadChange="uploadBack" />
        </span>
      </div>
      <div class="form-item">
        <span class="form-label required">投诉内容：</span>
        <span class="form-input">
          <textarea
            v-model="content"
            type="textarea"
            maxlength="2000"
            @input="inputChange"
          ></textarea>
        </span>
        <div class="form-tips">
          <div class="notice">
            (填写申诉涉及的文章标题、网址等，限制2000字,一个标题或内容对应一个链接,若含多条链接请选择添加按钮)
          </div>
          <div class="remain">
            还可以输入
            <span>{{ leftWords }}</span
            >个字
          </div>
        </div>
      </div>
      <div class="form-item form-add">
        <div class="add-input">
          <span class="form-label"></span>
          <span class="form-input">
            <input v-model="link" type="text" maxlength="1000" placeholder />
          </span>
          <div class="form-tips">
            <span class="add" @click="addNewTodo">添加</span>
            <span class="notice">(请输入涉及的链接)</span>
          </div>
        </div>
        <!-- <div class="err">
            {{linkError}}
        </div> -->
        <div class="todo-list" v-for="(todo, index) in todos" :key="index">
          <hy-todo-content
            v-model="todo.content"
            @remove="todos.splice(index, 1)"
          />
          <hy-todo-link
            v-model="todo.link"
            @remove="todos.splice(index, 1)"
            @add="addNewTodo"
          />

          <!-- <span class="todo-add" @click="addNewTodo">添加</span> -->
        </div>
      </div>
      <div class="form-item">
        <span class="form-label required">投诉原因：</span>
        <span class="form-input">
          <textarea
            type="textarea"
            v-model="complaintForm.complaintReason"
            maxlength="1000"
          ></textarea>
        </span>
        <div class="form-tips">
          <div class="notice">(对投诉原因的具体描述，限制1000字)</div>
        </div>
      </div>
      <div class="form-item">
        <span class="form-label required">投诉请求：</span>
        <span class="form-input">
          <textarea
            type="textarea"
            style="height:144px"
            v-model="complaintForm.complaintAppeal"
            maxlength="500"
          ></textarea>
        </span>
        <div class="form-tips">
          <div class="notice">
            (对需要处理的段落，语句或处理要求的具体描述，全文删除请注明。限制500字)
          </div>
        </div>
      </div>
      <div class="form-item form-cap">
        <span class="form-label required">验证码：</span>
        <span class="form-input">
          <input type="text" v-model="verCode" placeholder />
        </span>
        <div class="form-tips">
          <div class="notice">
            <img :src="captcha" />
            <span class="refresh" @click="getCaptcha">刷新</span>
          </div>
        </div>
      </div>
    </div>
    <form-type @radioChange="radioChange" @attachChange="attachChange" />
    <div class="agree">
      <i :class="[checked ? 'checked' : '']" @click="checked = !checked" />
      <span
        >我保证我填写的内容真实有效，由以上操作所引起的后果与搜狐无关，由我本人承担。</span
      >
    </div>
    <div
      class="complaint-btn"
      @click="submit"
      :style="{ opacity: isLoading ? '0.5' : '1' }"
    >
      提交投诉
    </div>
  </div>
</template>

<script>
import { HyUploadSingle } from "../../components/HyUpload";
import { HyUploadMultiple } from "../../components/HyUpload";
import { HyTodoLink, HyTodoContent } from "../../components/HyTodo";
import FormType from "./components/FormType";
import { save, getCaptcha } from "../../api/audit";
import { complaintCategoryOption } from "@/utils/const";

const nonageOption = [
  {
    label: "色情低俗",
    value: 1
  },
  {
    label: "暴力欺凌",
    value: 2
  },
  {
    label: "侮辱攻击威胁",
    value: 3
  },
  {
    label: "个人隐私信息",
    value: 4
  },
  {
    label: "诽谤未成年",
    value: 5
  },
  {
    label: "宣扬不健康风气",
    value: 6
  }
];
export default {
  components: {
    HyUploadSingle,
    HyUploadMultiple,
    HyTodoLink,
    HyTodoContent,
    FormType
  },
  data() {
    return {
      content: "",
      link: "",
      todos: [],
      checked: false,
      nonageReason: null,
      nonageOption: nonageOption,
      complaintCategory: null,
      complaintCategoryOption: complaintCategoryOption,
      complaintForm: {
        name: "",
        phone: "",
        complaintAppeal: "",
        complaintReason: ""
      },
      frontPic: {},
      backPic: {},
      attachPicList: [],
      leftWords: 2000,
      verCode: "",
      captcha: "",
      reset: false,
      linkError: "",
      isLoading: false
    };
  },
  computed: {
    btnDisabled() {
      return (
        !this.complaintForm.name.trim() ||
        !this.complaintForm.phone.trim() ||
        !this.complaintForm.complaintReason.trim() ||
        !this.complaintForm.complaintAppeal.trim() ||
        !this.content.trim() ||
        !this.frontPic.name ||
        !this.backPic.name
      );
    }
  },
  mounted() {
    this.getCaptcha();
  },
  methods: {
    addNewTodo() {
      this.todos.push({
        link: "",
        content: ""
      });
      // this.content = "";
      // this.link = "";
    },
    uploadFront(obj) {
      obj.type = 1;
      this.frontPic = obj;
      console.log(obj);
    },
    uploadBack(obj) {
      obj.type = 2;
      this.backPic = obj;
      console.log(obj);
    },
    radioChange(type) {
      this.complaintForm.complaintType = type;
      console.log(type);
    },
    attachChange(filearr) {
      console.log(filearr);
      this.attachPicList = filearr;
    },
    inputChange() {
      this.leftWords = 2000 - this.content.trim().length;
    },
    linkInputChange(e) {
      const val = e.target.value;
      if (
        val.indexOf("http://") === 0 ||
        val.indexOf("https://") === 0 ||
        !val
      ) {
        this.linkError = "";
        return;
      }
      this.linkError = "请输入有效链接";
    },
    getCaptcha() {
      getCaptcha().then(res => {
        this.captcha = res.status === 100000 && res.data.image;
        this.verKey = res.status === 100000 && res.data.key;
      });
    },
    checkReqiured() {
      if (!this.complaintForm.name) {
        this.$toast("请填写真实姓名");
        return false;
      }
      if (!this.complaintForm.phone) {
        this.$toast("联系电话为空");
        return false;
      }
      // if (
      //   !/\d+/.test(this.complaintForm.phone) ||
      //   this.complaintForm.phone.length > 30
      // ) {
      //   this.$toast("联系电话应为30位以内数字");
      //   return false;
      // }
      if (this.complaintCategory == null) {
        this.$toast("请填写投诉类型");
        return false;
      }
      // 当投诉类型不是【涉未成年人】时需要上传身份证照片
      if (this.complaintCategory != 6) {
        if (!this.frontPic.name) {
          this.$toast("请上传身份证正面照");
          return false;
        }
        if (!this.backPic.name) {
          this.$toast("请上传身份证反面照");
          return false;
        }
      }

      if (!this.content || !this.link) {
        this.$toast("最少填一个投诉内容和投诉链接");
        return false;
      }
      if (!this.complaintForm.complaintReason) {
        this.$toast("请输入投诉原因");
        return false;
      }
      if (!this.complaintForm.complaintAppeal) {
        this.$toast("请输入投诉请求");
        return false;
      }
      if (!this.verCode) {
        this.$toast("请输入图片验证码");
        return false;
      }
      if (this.verCode.length !== 4) {
        this.$toast("图片验证码错误");
        return false;
      }
      if (!this.checked) {
        this.$toast("请先勾选同意条款");
        return false;
      }
      return true;
    },
    submit() {
      if (this.isLoading) {
        return;
      }
      if (!this.checkReqiured()) {
        return;
      }
      let files = [this.frontPic, this.backPic, ...this.attachPicList].filter(
        value => Object.keys(value).length !== 0
      );
      let contentArr = [
        {
          link: this.link,
          content: this.content
        },
        ...this.todos
      ];
      let contents = [];
      contentArr.forEach(item => {
        if (!(item.content.trim() === "" && item.link.trim() === "")) {
          contents.push({
            link: item.link.trim(),
            content: item.content.trim()
          });
        }
      });
      const data = {
        name: this.complaintForm.name.trim(),
        phone: this.complaintForm.phone.trim(),
        complaintReason: this.complaintForm.complaintReason.trim(),
        complaintType: this.complaintForm.complaintType || 1,
        complaintAppeal: this.complaintForm.complaintAppeal.trim(),
        verCode: this.verCode,
        verKey: this.verKey,
        complaintCategory: this.complaintCategory,
        files,
        contents
      };
      this.isLoading = true;
      save(data)
        .then(res => {
          if (res.status === 100000) {
            this.$toast(
              "投诉成功，我方工作人员会尽快处理您的问题，您也可以致电客服中心010-58511234 查询处理进度和处理结果"
            );
            setTimeout(() => {
              this.isLoading = false;
              this.$router.push("/record");
            }, 5000);
          } else {
            this.$toast(res.desc || "提交失败");
            this.isLoading = false;
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
          this.$toast(err || "请求失败");
        });
    },
    resetData() {
      this.getCaptcha();
      this.content = "";
      this.link = "";
      this.todos = [];
      this.checked = false;
      this.complaintForm = {
        name: "",
        phone: "",
        complaintAppeal: "",
        complaintReason: ""
      };
      this.frontPic = {};
      this.backPic = {};
      this.attachPicList = [];
      this.leftWords = 2000;
      this.verCode = "";
      this.reset = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.form-container {
  width: 993px;
  margin: 0 auto;
  .tips {
    line-height: 40px;
    text-align: center;
    background: rgba(255, 253, 221, 1);
    border-radius: 4px;
    border: 1px solid rgba(241, 148, 50, 1);
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
  }
}

@mixin require() {
  position: relative;
  &::before {
    content: "*";
    position: absolute;
    color: red;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

.form {
  border: 1px solid rgba(151, 151, 151, 1);
  margin-top: 18px;
  border-radius: 10px;
  padding: 26px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  input,
  textarea {
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(151, 151, 151, 1);
    font-size: 20px;
    box-sizing: border-box;
    padding-left: 8px;
  }
  textarea {
    width: 554px;
    padding-top: 8px;
    height: 212px;
  }
  .form-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 27px;
    .form-label {
      padding-left: 10px;
      line-height: 40px;
      min-width: 100px;
    }
    .required {
      @include require;
    }
    .form-input {
      display: inline-block;
      input {
        width: 371px;
        line-height: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(151, 151, 151, 1);
        font-size: 20px;
        padding-left: 8px;
        &::-webkit-input-placeholder {
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(174, 174, 174, 1);
        }
      }
      .hy-link {
        width: 554px;
      }
    }
    .form-upload {
      margin-top: 4px;
    }
    .form-tips {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(105, 105, 105, 1);
      line-height: 21px;
      padding-left: 16px;
      .notice {
        margin-bottom: 17px;
        margin-top: 4px;
        img {
          width: 84px;
          height: 35px;
        }
        .refresh {
          display: inline-block;
          margin-bottom: 10px;
          line-height: 35px;
          vertical-align: top;
          margin-left: 16px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(66, 149, 210, 1);
          cursor: pointer;
        }
      }
      .remain {
        span {
          font-size: 20px;
        }
      }
      .add {
        cursor: pointer;
        display: inline-block;
        margin-right: 16px;
        width: 60px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(151, 151, 151, 1);
        line-height: 28px;
        margin-top: 8px;
        text-align: center;
        color: #000000;
        font-size: 16px;
      }
    }
  }
  .form-add {
    margin-top: -20px;
    display: flex;
    flex-direction: column;
    .add-input {
      display: flex;
    }
    .form-input {
      input {
        width: 554px;
      }
    }
  }
  .form-cap {
    margin-bottom: 0;
    .form-input {
      input {
        width: 115px;
      }
    }
  }
}
.nonage-reason {
  display: flex;
  align-items: center;
  margin-bottom: 27px;
  .required {
    @include require;
  }
  span {
    margin-right: 10px;
    padding-left: 10px;
  }
}
.nonage {
  display: flex;
  margin-bottom: 27px;
  align-items: center;
  i {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 2px solid rgba(174, 174, 174, 1);
    box-sizing: border-box;
    cursor: pointer;
  }
  .checked {
    border: none;
    background: url("../../assets/images/ic_kehuyouxiao@2x.png") no-repeat
      center center;
    background-size: contain;
  }
  .required {
    @include require;
  }
  span {
    margin-right: 10px;
    padding-left: 10px;
  }
}
.agree {
  display: flex;
  margin-top: 24px;
  align-items: center;

  i {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 2px solid rgba(174, 174, 174, 1);
    box-sizing: border-box;
    cursor: pointer;
  }
  .checked {
    border: none;
    background: url("../../assets/images/ic_kehuyouxiao@2x.png") no-repeat
      center center;
    background-size: contain;
  }
  span {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(105, 105, 105, 1);
    margin-left: 10px;
  }
}
.complaint-btn {
  width: 281px;
  line-height: 81px;
  background: rgba(42, 151, 212, 1);
  border-radius: 10px;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  margin: 62px auto 0;
  text-align: center;
  cursor: pointer;
}
.todo-list {
  position: relative;
}
.todo-add {
  position: absolute;
}
.err {
  color: red;
  margin: 10px 0 -20px 110px;
}
</style>
